// extracted by mini-css-extract-plugin
module.exports = {"loading_dots":"loading-dots_loading_dots__J7CPx","spacer":"loading-dots_spacer__IXM4o","blink":"loading-dots_blink__IuO51"};